import { ACCESS_LEVEL_ADMIN, ACCESS_LEVEL_USER } from '../../utlities/core.constants';

/** Request is for vendor org when it has vendorId (buyer requests use agencyId). */
export function isVendorSideAccessRequest(request) {
  return Boolean(request?.vendorId);
}

/** Human-readable role for tags: Admin, Vendor Editor, or Buyer User. */
export function displayAccessLevelRoleName(level, request) {
  if (level === ACCESS_LEVEL_ADMIN) {
    return 'Admin';
  }
  if (level === ACCESS_LEVEL_USER) {
    return isVendorSideAccessRequest(request) ? 'Vendor Editor' : 'Buyer User';
  }
  return level ?? '';
}

/** Approve / change-level dropdown: Admin + t2; t2 label is Editor (vendor) or User (buyer). */
export function accessLevelDropdownOptionsForRequest(request) {
  const isVendor = isVendorSideAccessRequest(request);
  return [
    { label: 'Admin', value: ACCESS_LEVEL_ADMIN },
    { label: isVendor ? 'Editor' : 'User', value: ACCESS_LEVEL_USER },
  ];
}

/** Same as {@link accessLevelDropdownOptionsForRequest} when vendor vs buyer is already known from UI section. */
export function accessLevelDropdownOptionsForGroup(isVendor) {
  return [
    { label: 'Admin', value: ACCESS_LEVEL_ADMIN },
    { label: isVendor ? 'Editor' : 'User', value: ACCESS_LEVEL_USER },
  ];
}
